import React, { FunctionComponent } from "react";
import { Attributes } from "./component";

export const AttributesContainer: FunctionComponent = () => {
  return <Attributes />;
};
